(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('careerTabSwitchReset', careerTabSwitchReset);

    function careerTabSwitchReset() {
        return {
            restrict: 'A',
            link: function(scope, elem, attr) {
                var nonActiveTabs = elem.find('.k-tabstrip > ul > li');
                var targetClass = attr.targetClass;
                nonActiveTabs.click(function() {
                    var currentElem = $(this);

                    if (currentElem.hasClass('.k-state-active')) {
                        return;
                    }
                    $(targetClass).show();
                    if (typeof scope.func.showList === typeof function() {}) {
                        scope.func.showList();
                        scope.$apply();
                    }
                });

                scope.$on('$destroy', function() {
                    nonActiveTabs.off();
                });
            }
        };
    }
})();